interface IProps {
  className?: string;
  alt: string;
  src?: string;
}

const Image: React.FC<IProps> = props => {
  // const [isTokenIconExist, setTokenIconExist] = useState<boolean>();
  // useEffect(() => {
  //   if (props.src && typeof isTokenIconExist !== 'boolean') {
  //     setTokenIconExist(isImageExist(props.src));
  //   }
  // }, [props.src, isTokenIconExist]);
  // if (!isTokenIconExist) return null;
  return <img {...props} />;
};

export default Image;
